import React from 'react'
import { Close } from '@cmsgov/ds-medicare-gov'

export interface DrawerProps {
  className?: string;
  children?: React.ReactNode;
  title: string;
  onClose: () => void;
  isOpen: boolean;
}

export const Drawer: React.FC<DrawerProps> = ({ className, children, title, onClose, isOpen }) => {
  return isOpen ? (
    <>
      <div className={`ch-c-drawer__overlay ${className}`} />
      <div className={`ch-c-drawer__content ${className}`}>
        <div className='ch-c-drawer__header'>
          <span>{title}</span>
          <button
            className='ds-c-button ch-c-button--transparent ds-u-padding--0'
            // eslint-disable-next-line jsx-a11y/no-autofocus
            autoFocus
            aria-label='Close'
            onClick={onClose}
            type='button'
            data-testid='drawer-close-btn'
          >
            <Close />
          </button>
        </div>
        {children}
      </div>
    </>
  ) : null
}
